import axios from '@axios'

export default {
  namespaced: true,
  state: {
    referralCode: '',
    referralCodes: [],
    referrals: [],
  },
  getters: {
    referralCode: state => state.referralCode,
    referralCodes: state => state.referralCodes,
    referrals: state => state.referrals,
  },
  mutations: {
    setReferralCode(state, referralCode) {
      state.referralCode = referralCode
    },
    setReferralCodes(state, referralCodes) {
      state.referralCodes = referralCodes
    },
    setReferrals(state, referrals) {
      state.referrals = referrals
    },
    addReferralCode(state, referralCode) {
      state.referralCode = referralCode
      state.referralCodes.unshift(referralCode)
    },
  },
  actions: {
    async createReferralCode(ctx, { code, description }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/referral-codes', { code, description })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    async getReferralCodes(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/referral-codes', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    async getReferrals(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/referrals', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    async fetchReferral(ctx, { id }) {
      const response = await axios.get(`/referrals/${id}?include=manager,languages,service_offers.point_purposes,service_offers.point_type,service_offers.address,subscriptions.abilities.limits`)
        .catch(error => {
          if (error.response.status === 404) {
            return error.response
          }
          console.log(error)
        })

      return response
    },
  },
}
